"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _maybeAddPeriod = _interopRequireDefault(require("../utils/maybe-add-period"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ControlWrapper =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ControlWrapper, _React$PureComponent);

  function ControlWrapper() {
    _classCallCheck(this, ControlWrapper);

    return _possibleConstructorReturn(this, _getPrototypeOf(ControlWrapper).apply(this, arguments));
  }

  _createClass(ControlWrapper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          themeControlWrapper = _this$props.themeControlWrapper,
          validationError = _this$props.validationError;
      var errorEl = null;

      if (validationError) {
        var validationErrorId = "".concat(this.props.id, "-error");
        var errorBody = typeof validationError === 'string' ? (0, _maybeAddPeriod.default)(validationError) : validationError;
        errorEl = _react.default.createElement("div", {
          className: "bg txt-s mt3 py6 px12 bg-red-faint round border border--red color-red",
          id: validationErrorId,
          "data-test": validationErrorId
        }, errorBody);
      }

      var wrapperClasses = "relative ".concat(themeControlWrapper);
      return _react.default.createElement("div", {
        className: wrapperClasses
      }, children, _react.default.createElement("div", {
        role: "alert"
      }, errorEl));
    }
  }]);

  return ControlWrapper;
}(_react.default.PureComponent);

exports.default = ControlWrapper;

_defineProperty(ControlWrapper, "propTypes", {
  /** Should correspond to the identifier of the input. */
  id: _propTypes.default.string.isRequired,

  /**
   * If provided, the value of this property will show up as an error message.
   * Strings will end with periods.
   */
  validationError: _propTypes.default.node,

  /** The contents the controlWrapper contains */
  children: _propTypes.default.node,

  /** A space separated list of Assembly class names to override the existing presentation. */
  themeControlWrapper: _propTypes.default.string
});

_defineProperty(ControlWrapper, "defaultProps", {
  themeControlWrapper: ''
});